import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const satisfiedCounterSlice = createSlice({
  name: "satisfiedCounter",
  initialState,
  reducers: {
    fetchSatisfiedCounter: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSatisfiedCounterSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload; // raw API data
    },
    fetchSatisfiedCounterFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchSatisfiedCounter,
  fetchSatisfiedCounterSuccess,
  fetchSatisfiedCounterFailure,
} = satisfiedCounterSlice.actions;

export default satisfiedCounterSlice.reducer;
